import { Icons } from '@/components/Shares/Icons';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { ActionIcon, Popover } from '@mantine/core';
import { useState } from 'react';
export const EmojiPicker: React.FC = () => {
  const [opened, setOpened] = useState<boolean>(false);
  return <Popover position="top-start" opened={opened} onChange={() => setOpened(false)}>
      <Popover.Target>
        <ActionIcon variant="transparent" style={{
        pointerEvents: 'auto'
      }} onClick={() => setOpened(!opened)}>
          <Icons className="icon-pr-line-face-smile" fontSize={20} color="var(--text-grey-2)" />
        </ActionIcon>
      </Popover.Target>

      <Popover.Dropdown>
        <Picker data={data} previewPosition="none" maxFrequentRows={3} onEmojiSelect={({
        native
      }: {
        native: string;
      }) => console.log(native)} />
      </Popover.Dropdown>
    </Popover>;
};